import { Menu, X } from "lucide-react"
import { useState } from "react"
import { motion } from "framer-motion"
import { Button } from "../ui/Button"

export function Header() {
  const [open, setOpen] = useState(false)

  return (
    <motion.header className="site-header" initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
      <a className="brand" href="#inicio" aria-label="Equipe Cell — início">
        <img src="/logo equipe cell sem fundo.png" alt="Equipe Cell" />
      </a>
      <nav className={`nav ${open ? "nav--open" : ""}`} aria-label="Navegação principal">
        <a href="#servicos" onClick={() => setOpen(false)}>Serviços</a>
        <a href="#sobre" onClick={() => setOpen(false)}>Como funciona</a>
        <a href="#localizacao" onClick={() => setOpen(false)}>Localização</a>
        <Button href="#contato" arrow={false} onClick={() => setOpen(false)}>Pedir orçamento</Button>
      </nav>
      <button className="menu-button" type="button" aria-label={open ? "Fechar menu" : "Abrir menu"} aria-expanded={open} onClick={() => setOpen(!open)}>
        {open ? <X /> : <Menu />}
      </button>
    </motion.header>
  )
}
